import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { StyledServiceWorkerWrapper, StyledServiceWorkerText, StyledServiceWorkerButton } from './styled';
import * as serviceWorker from '../../serviceWorker';

const ServiceWorkerWrapper = () => {
    const { t } = useTranslation();
    const [showReload, setShowReload] = React.useState(false);
    const [waitingWorker, setWaitingWorker] = React.useState(null);
    const onSWUpdate = (registration) => {
        setShowReload(true);
        setWaitingWorker(registration.waiting);
    };

    const reloadPage = () => {
        waitingWorker && waitingWorker.postMessage({ type: 'SKIP_WAITING' });
        setShowReload(false);
        window.location.reload(true);
    };

    useEffect(() => {
        // If you want your app to work offline and load faster, you can change
        // unregister() to register() below. Note this comes with some pitfalls.
        // Learn more about service workers: https://bit.ly/CRA-PWA
        serviceWorker.register({ onUpdate: onSWUpdate });
    }, []);

    useEffect(() => {
        if (showReload) {
            toast.success(<StyledServiceWorkerWrapper>
                <StyledServiceWorkerText>{t('service_worker.text')}</StyledServiceWorkerText>
                <StyledServiceWorkerButton onClick={reloadPage}>{t('service_worker.button')}</StyledServiceWorkerButton>
            </StyledServiceWorkerWrapper>, {
                autoClose: false,
                closeOnClick: false
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showReload]);

    return null;
}
export default ServiceWorkerWrapper;